// This patch prevents creating new history entry when trying to enter the same location
// https://github.com/ReactTraining/history/issues/470#issuecomment-445217562

export function patchHistory(customHistory) {
    const prevHistoryPush = customHistory.push;
    let lastLocation = customHistory.location;

    customHistory.listen(location => {
        lastLocation = location;
    });
    customHistory.push = (pathname, state = {}) => {
        if (
            lastLocation === null ||
            pathname !== lastLocation.pathname + lastLocation.search + lastLocation.hash ||
            JSON.stringify(state) !== JSON.stringify(lastLocation.state)
        ) {
            prevHistoryPush(pathname, state);
        }
    };
    return customHistory;
}



// WEBPACK FOOTER //
// /src/configuration/patches.js